/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmergencyContactHouseResponseDto } from './EmergencyContactHouseResponseDto';
import type { EmergencyContactOwnerResponseDto } from './EmergencyContactOwnerResponseDto';
export type EmergencyContactInvitationResponseDto = {
  /**
   * Id of invitation.
   */
  id: number;
  status: EmergencyContactInvitationResponseDto.status;
  /**
   * Client who sent the invitation for an emergency contact
   */
  owner: EmergencyContactOwnerResponseDto;
  /**
   * Owner's houses which the emergency contact is assigned to.
   */
  houses: Array<EmergencyContactHouseResponseDto>;
  createdAt?: string;
  updatedAt?: string;
};
export namespace EmergencyContactInvitationResponseDto {
  export enum status {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
  }
}

